var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-responsive',{attrs:{"aspect-ratio":16/9}},[_c('script',{ref:"player",attrs:{"data-videohub-id":_vm.content.content,"src":`https://evolucional.videohub.com.br/embed.js?${_vm.now}`,"type":"module"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }